 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Deposit":"Deposit","UserInfo":"UserInfo","Withdrawal":"Withdrawal","about":"about","DepositRecord":"DepositRecord","WithdrawalRecord":"WithdrawalRecord","forexBonus":"forexBonus","fundStreams":"fundStreams","message":"message","miningRewards":"miningRewards","withdrawal":"withdrawal"}[chunkId]||chunkId) + "." + {"Deposit":"d9b66c40","UserInfo":"9bb5c7fc","Withdrawal":"a1f99dd6","about":"c98dd876","chunk-07b104ea":"8a963959","chunk-0a4b7e10":"e38ce9a4","DepositRecord":"274410ba","WithdrawalRecord":"da888a4c","chunk-2d0be68c":"5e9bc0f5","chunk-2d0c498d":"6d4ec532","chunk-4f43b3e0":"0c6f6348","chunk-5770b64c":"67e01dbb","chunk-5dc034d8":"2a6e7258","chunk-0aea2a4c":"ff591da8","chunk-1eb109c2":"c54dbb08","chunk-1f56af0b":"7622ad9c","chunk-26199514":"198ba0d3","chunk-2907c8d6":"e6fc9293","chunk-2c1f9136":"35229970","chunk-2f1fdba7":"59ae6c4c","chunk-3f11a9ea":"034835f5","chunk-439ca302":"b065f4b4","chunk-6395d224":"aa27aa7b","chunk-67a883bb":"06bb9304","chunk-6b8eeb3a":"b2ae3492","chunk-74a0b705":"cb98219c","chunk-79866464":"471c20c8","chunk-7a9f3a0a":"7eeca6c2","chunk-7c0ec835":"1a487f1b","chunk-8f14f1f6":"732109c9","chunk-a71818de":"52abaaec","chunk-db9a64a4":"a99f72e4","chunk-e38098e6":"f5154257","chunk-fb6016fa":"4cea60de","forexBonus":"93d939d5","fundStreams":"5c31f2eb","message":"5a32d949","miningRewards":"a5e15b1f","withdrawal":"635b3282"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Deposit":1,"UserInfo":1,"Withdrawal":1,"about":1,"chunk-0a4b7e10":1,"chunk-4f43b3e0":1,"chunk-5770b64c":1,"chunk-5dc034d8":1,"chunk-0aea2a4c":1,"chunk-1f56af0b":1,"chunk-26199514":1,"chunk-2f1fdba7":1,"chunk-3f11a9ea":1,"chunk-439ca302":1,"chunk-6395d224":1,"chunk-67a883bb":1,"chunk-6b8eeb3a":1,"chunk-74a0b705":1,"chunk-79866464":1,"chunk-7c0ec835":1,"chunk-8f14f1f6":1,"chunk-db9a64a4":1,"chunk-e38098e6":1,"chunk-fb6016fa":1,"forexBonus":1,"message":1,"miningRewards":1,"withdrawal":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Deposit":"Deposit","UserInfo":"UserInfo","Withdrawal":"Withdrawal","about":"about","DepositRecord":"DepositRecord","WithdrawalRecord":"WithdrawalRecord","forexBonus":"forexBonus","fundStreams":"fundStreams","message":"message","miningRewards":"miningRewards","withdrawal":"withdrawal"}[chunkId]||chunkId) + "." + {"Deposit":"c51472f5","UserInfo":"873b9085","Withdrawal":"cf2b21e2","about":"e63d0ed1","chunk-07b104ea":"31d6cfe0","chunk-0a4b7e10":"49e46744","DepositRecord":"31d6cfe0","WithdrawalRecord":"31d6cfe0","chunk-2d0be68c":"31d6cfe0","chunk-2d0c498d":"31d6cfe0","chunk-4f43b3e0":"1e164c8e","chunk-5770b64c":"7536670e","chunk-5dc034d8":"3da37bba","chunk-0aea2a4c":"49878808","chunk-1eb109c2":"31d6cfe0","chunk-1f56af0b":"3a80ab69","chunk-26199514":"e56c375d","chunk-2907c8d6":"31d6cfe0","chunk-2c1f9136":"31d6cfe0","chunk-2f1fdba7":"a2eb5490","chunk-3f11a9ea":"a6b61bdf","chunk-439ca302":"c611391d","chunk-6395d224":"72ee3c1f","chunk-67a883bb":"f0f8009a","chunk-6b8eeb3a":"7df4f43a","chunk-74a0b705":"59d73d15","chunk-79866464":"3a311b84","chunk-7a9f3a0a":"31d6cfe0","chunk-7c0ec835":"8263bb01","chunk-8f14f1f6":"bb913f16","chunk-a71818de":"31d6cfe0","chunk-db9a64a4":"3b70d4e1","chunk-e38098e6":"73169abc","chunk-fb6016fa":"b0d1b94b","forexBonus":"a1a83479","fundStreams":"31d6cfe0","message":"9a04c95e","miningRewards":"727b97e7","withdrawal":"7f2610a2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
